import { render, staticRenderFns } from "./JobMain.vue?vue&type=template&id=5ca83d9b&"
import script from "./JobMain.vue?vue&type=script&lang=js&"
export * from "./JobMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports